import React, { useState, useCallback, useMemo, useEffect } from 'react';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isEmpty } from 'lodash';
import * as Yup from 'yup';

import { isNull, isArray, concat, trim } from 'lodash';

import { toast } from 'react-toastify';
import api from '~/services/api';

import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  Select,
  RadioGroup,
} from '~/components/Form';

export default function Relvazaonaoautorizadaperiodo() {
  const [open, setOpen] = useState(true);
  const [produto, setProduto] = useState({});
  const [userPost, setUserPost] = useState({});
  const [tank, setTank] = useState({});

  const [valueProdCodigo, setValueProdCodigo] = useState(undefined);
  const [valuePocoCodigo, setValuePocoCodigo] = useState(undefined);


  const [wherefieldTQ, setWhereFieldTQ] = useState(['prod_codigo']);
  const [valuewherefieldTQ, setValueWhereFieldTQ] = useState([0]);
  const [typewherefieldTQ, setTypeWhereFieldTQ] = useState(['EQUALS']);

  const [inputValueTanque, setInputValueTanque] = React.useState('');


  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const condition = useMemo(() => {
    const wherefield = [];
    const valuewherefield = [];
    const typewherefield = [];

    if (!isEmpty(produto)) {
      wherefield.push('prod_codigo');
      valuewherefield.push(produto.prod_codigo);
      typewherefield.push('EQUALS');
    }

    if (!isEmpty(userPost)) {
      wherefield.push('poco_codigo');
      valuewherefield.push(userPost.poco_codigo);
      typewherefield.push('EQUALS');
    }

    return {
      wherefield,
      valuewherefield,
      typewherefield
    }
  }, [produto, userPost]);


  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        // datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        produto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')).nullable(),
        posto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')).nullable(),
        tanque: Yup.string().required(t('s.geral.validacao.campoobrigatorio')).nullable(),
      });

      let tanque = data.tanque;

      if (inputValueTanque === '') {
        tanque = undefined;
      }
      let objdata = { ...data, tanque };

      await schema.validate(objdata, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, [inputValueTanque]);

  const onSerializeData = useCallback((data) => ({
    ...data,
    produtostr: produto.prod_descricao,
    postostr: userPost.poco_descricao,
    tanquestr: tank.tafi_nome,
  }), [produto, userPost, tank]);


  const handleGetTanques = useCallback(async () => {
    try {

      const wherefield = [];
      const valuewherefield = [];
      const typewherefield = [];

      wherefield.push('prod_codigo');
      valuewherefield.push(valueProdCodigo !== undefined ? valueProdCodigo : '9999999');
      typewherefield.push('EQUALS');

      wherefield.push('poco_codigo');
      valuewherefield.push(valuePocoCodigo !== undefined ? valuePocoCodigo : '9999999');
      typewherefield.push('EQUALS');

      setWhereFieldTQ(wherefield);
      setValueWhereFieldTQ(valuewherefield);
      setTypeWhereFieldTQ(typewherefield);


    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [valueProdCodigo, valuePocoCodigo]);


  useEffect(() => {
    handleGetTanques();
  }, [valueProdCodigo, valuePocoCodigo]);



  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="VAZÃO NÃO AUTORIZADA DO POSTO NO PERÍODO"
      relatorio="vazaonaoautorizadapostoperiododata"
      initials={{
        datahorainicial,
        datahorafinal,
        formato: 'pdf',
        dispositivoinstalado: 1,
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="produtos"
        url="produtos"
        unique="prod_codigo"
        getValue={
          (value) => {
            setProduto(value);
            setInputValueTanque('');
            if (value.prod_codigo !== null) {
              setValueProdCodigo(value.prod_codigo);
            } else {
              setValueProdCodigo(undefined);
            }
          }
        }
      />

      <Autocomplete
        name="posto"
        label="poco_desc_abrev"
        title="Posto"
        url="postosporusuario"
        unique="poco_codigo"
        getValue={
          (value) => {
            setUserPost(value);
            setInputValueTanque('');
            if (value.poco_codigo !== null) {
              setValuePocoCodigo(value.poco_codigo);
            } else {
              setValuePocoCodigo(undefined);
            }
          }
        }
      />

      <Autocomplete
        id="idtanque"
        name="tanque"
        label="tafi_nome"
        title="Tanque Fisico"
        url="tanquesfisicos"
        unique="tafi_codigo"
        inputValue={inputValueTanque}
        params={{
          wherefield: wherefieldTQ,
          valuewherefield: valuewherefieldTQ,
          typewherefield: typewherefieldTQ
          // wherefield: condition.wherefield,
          // valuewherefield: condition.valuewherefield,
          // typewherefield: condition.typewherefield
        }}
        //disabled={valueProdCodigo === undefined && valuePocoCodigo === undefined}
        getValue={(value) => {

          if (value.tafi_nome !== null) {
            setInputValueTanque(value.tafi_nome);
          } else {
            setInputValueTanque('');
          }

          setTank(value)

        }}
      />




      <RadioGroup
        row
        name="tipo"
        label="Formato"
        defaultValue="pdf"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  )
}
